import { trigger, state, style, animate, transition } from '@angular/animations';

export const Animations = {
  BlinkRedError: trigger('blinkError', [
    state('red', style({
      borderColor: 'red'
    })),
    state('normal', style({
    })),
    transition('red <=> normal', [
      animate('0.1s')
    ]),
  ]),
  ColorRedExitButton: trigger('redBold', [
    state('red', style({
      color: 'red'
    })),
    state('normal', style({
    })),
    transition('red <=> normal', [
      animate('0.1s')
    ]),
  ]),
  ColorBlueButton: trigger('blueBold', [
    state('blue', style({
      color: 'aqua'
    })),
    state('normal', style({
    })),
    transition('blue <=> normal', [
      animate('0.1s')
    ]),
  ]),
  OutIn: trigger('OutIn', [
    state('Out', style({
      left: '{{left}}px'
    }), {params: {left: '0px'}}),
    state('In', style({
      left: '{{left}}px',
      opacity: 0
    }), {params: {left: '0px'}}),
    transition('Out <=> In', [
      animate('0.12s')
    ]),
  ]),
  ButtonClicked: trigger('BackgroundColor', [
    state('Light', style({
      backgroundColor: '#D9E2EC'
    })),
    state('normal', style({
    })),
    transition('Light <=> normal', [
      animate('0.1s')
    ]),
  ]),
  ButtonClickedInverted: trigger('BackgroundColorInverted', [
    state('normal', style({
    })),
    state('Dark', style({
      color: '#12122a'
    })),
    transition('normal <=> Dark', [
      animate('0.1s')
    ]),
  ]),
  WindowOpenCloseFadeHeight: trigger('WindowOpenClose', [
    state('visible', style({
    })),
    state('invisible', style({
      opacity: '0%',
      height: '0px'
    })),
    transition('visible <=> invisible', [
      animate('0.2s')
    ]),
  ]),
  WindowOpenCloseFade: trigger('WindowOpenCloseFade', [
    state('visible', style({
    })),
    state('invisible', style({
      opacity: '0%',
    })),
    transition('visible <=> invisible', [
      animate('10s')
    ]),
  ]),
  WindowShrink: trigger('WindowShrink', [
    state('normal', style({
    })),
    state('shrinked', style({
      height: '70px'
    })),
    transition('normal <=> shrinked', [
      animate('0.2s')
    ]),
  ]),
}